module.exports = __webpack_public_path__ + "static/4-5cf66389b49551655b99409a62bcde3c.png";